@if ({ row: columnData | async }; as $) {
  <p-popover
    #opclientinfo
    styleClass="overflow-hidden text-sm"
    appendTo="body"
    [dismissable]="true"
  >
    <ng-template #content>
      <!-- Dropdown Content -->
      <div
        class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2"
      >
        <div class="flex mt-2 w-10rem line-height-1">
          <span class="text-base font-medium text-800">{{
            $.row.client_info.full_name | titlecase
          }}</span>
          <span class="text-xs text-600 ml-1 mt-1">{{
            $.row.client_info.id
          }}</span>
        </div>
        <div [innerHTML]="clientStatus($.row.client_info)"></div>
      </div>
      <!-- Dropdown Content -->
      <!-- Dropdown Footer -->
      @if ($.row) {
        <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs">
          @if ($.row.client_info?.mobile_number) {
            <div class="flex align-items-center mb-2">
              <i class="fa fa-phone mr-2 text-500"></i>
              {{ $.row.client_info.mobile_country_code }}
              {{ $.row.client_info.mobile_number }}
            </div>
          }
          @if ($.row.client_info?.email_id) {
            <div class="flex align-items-center mb-1">
              <i class="fa fa-envelope font-light mr-2 text-500"></i>
              <span class="break-word">{{ $.row.client_info.email_id }}</span>
            </div>
          }
        </div>
      }
      <!-- Dropdown Footer -->
    </ng-template>
  </p-popover>
  @if ($.row && $.row.client_info) {
    <div class="flex align-items-center">
      <span
        class="cursor-pointer flex align-items-center"
        (mouseenter)="opclientinfo.show($event)"
        (mouseleave)="opclientinfo.hide()"
        (click)="gotoClient($.row)"
      >
        @if (!$.row.client_info.image) {
          <p-avatar
            [label]="$.row.client_info.full_name | titlecase | shortName"
            styleClass="text-sm"
            shape="circle"
          />
        } @else {
          <p-avatar [image]="$.row.client_info.image" shape="circle" />
        }
        <strong class="ml-3 text-primary">{{
          $.row.client_info.full_name | titlecase
        }}</strong>
      </span>
    </div>
  }
}
